import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DropdownFilterEvent, DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {MultiSelectModule} from "primeng/multiselect";
import {TooltipModule} from "primeng/tooltip";
import {LabelWidth} from '../../../../defaults';
import {NgIf, NgTemplateOutlet} from '@angular/common';
import {FloatLabel} from 'primeng/floatlabel';

@Component({
  standalone: true,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  imports: [
    DropdownModule,
    FormsModule,
    MultiSelectModule,
    TooltipModule,
    NgIf,
    FloatLabel,
    NgTemplateOutlet
  ],
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnDestroy {

  private static inputElementCounter = 1;

  private readonly _inputElementId: number = ++DropdownComponent.inputElementCounter;

  get inputElementId(): string {
    return 'dropdownElement' + this._inputElementId;
  }

  @Input()
  showLength = true;

  @Input()
  model: any;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  label = '';

  @Input()
  dropdownItems: any[] = [];

  @Input()
  optionLabel = 'label';

  @Input()
  optionValue: string | undefined = undefined;

  @Input()
  showClear = false;

  @Input()
  showFilter = false;

  @Input()
  multiple = false;

  @Input()
  disabled = false;

  @Input()
  fullWidth = false;

  @Input()
  useFloatLabel: false | 'in' | 'on' | 'over' = false;

  @Input()
  createItemOnFly = false;

  @Output()
  onCreateFly: EventEmitter<any> = new EventEmitter();

  get hasLabel(): boolean {
    return this.label !== '';
  }

  @Input()
  labelWidth = LabelWidth;

  @Input()
  inputWidth = '200px';

  @Input()
  maxSelectableElements = 3;

  @Input()
  placeholder = 'Nessuna selezione';

  private _newItemId = 0;

  private _onFlyItemItem?: any = undefined;


  get selectedLabels(): string {
    if (Array.isArray(this.model)) {
      let resume = '';
      for (const item of this.model) {
        resume += item[this.optionLabel] + '<br>';
      }
      return resume;
    }
    return this.model;
  }

  get isTooltipEnabled(): boolean {
    if (Array.isArray(this.model)) {
      return this.model.length <= this.maxSelectableElements;
    }
    return false;
  }

  get ellipsesText(): string {
    if (this.model && this.model.length > 0) {
      const firstItems = this.model.slice(0, this.maxSelectableElements);
      const firstItemsLabels = firstItems.map((item: any) => item[this.optionLabel]);
      return firstItemsLabels.join(', ') + ' ...';
    }
    return '';
  }

  constructor() {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }


  filter(event: DropdownFilterEvent) {
    if (!this.createItemOnFly) {
      return;
    }
    // remove the item with id 0
    this._removeOnFlyItems();

    this._addOnFlyItem(event.filter);

  }

  onHide() {
    this._removeOnFlyItems();
  }

  private _removeOnFlyItems() {
    const index = this.dropdownItems.findIndex((item: any) => item[this.optionValue!] <= 0);
    if (index > -1) {
      this.dropdownItems.splice(index, 1);
    }
    this._onFlyItemItem = undefined;
  }

  private _addOnFlyItem(originalQuery: string) {
    const query = originalQuery.toLowerCase();
    const items = this.dropdownItems.filter((item: any) => item[this.optionLabel].toLowerCase().includes(query));
    if (items.length == 0) {
      const item = Object.create({});
      item[this.optionLabel] = originalQuery;
      if (this.optionValue) {
        item[this.optionValue] = --this._newItemId;
      }
      this.dropdownItems.push(item);
      this._onFlyItemItem = item;
    }
  }


  onModelChange($event: any) {
    if (this.createItemOnFly && this._onFlyItemItem && $event) {
      this.onCreateFly.emit(this._onFlyItemItem);
      this._removeOnFlyItems();
    }
    this.modelChange.emit($event);
  }
}
